// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  firmId: __t.u64().primaryKey().name("firm_id"),
  runs: __t.bool(),
  escortMult: __t.f64().name("escort_mult"),
  reason: __t.string(),
  runsLost: __t.u32().name("runs_lost"),
  runsArrived: __t.u32().name("runs_arrived"),
  updatedAt: __t.timestamp().name("updated_at"),
});
